import { useLayoutEffect, useState } from "react";

const isMobileViewport = () => (typeof window !== "undefined" ? window.innerWidth <= 768 : false);

export const useIsMobile = () => {
  const [isMobileValue, setIsMobileValue] = useState(isMobileViewport);
  useLayoutEffect(() => {
    function updateIsMobile() {
      setIsMobileValue(isMobileViewport());
    }
    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []);

  return isMobileValue;
};
